import { render, staticRenderFns } from "./LocationDelete.vue?vue&type=template&id=1c6387fe"
import script from "./LocationDelete.vue?vue&type=script&lang=js"
export * from "./LocationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports